<template>
    <section id="demo" class="grey lighten-3">
        <v-container class="text-center px-0 py-0">
          <h2 class="display-2 font-weight-bold mb-3">Examples</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-expand-transition>
          <v-carousel v-show="showDemo" interval=5000 class="px-0" height="auto">
            <v-carousel-item v-for="(example, i) in examples" :key="i" :src="example.src" contain></v-carousel-item>
          </v-carousel>
          </v-expand-transition>
        
        </v-container>
    </section>
</template>


<script>
    export default {
        name: 'ExampleBlock',

        data: () => ({
          showDemo: true,
          content_loaded: false,
          examples: []
        }),
        mounted(){
            if (!this.content_loaded) {
                this.$http
                    .get(this.getHost() + 'content/examples.json')
                    .then(function(data) {
                        this.examples = data.body;
                        let host = this.getHost();
                        for (let i in this.examples) {
                            this.examples[i]['src'] = host + "content/" + this.examples[i].image;
                        }
                    });
                this.content_loaded = true;
            }
        }
    }
</script>
